"use client";

import * as React from "react";
import { cn } from "../../lib/utils";

export interface ChatHeaderProps {
  /** Conversation title shown in the top bar; truncated. */
  title?: string;
  /** Optional brand node. Nothing is rendered in its place when absent. */
  brand?: React.ReactNode;
  /**
   * Opt-in slot the shell fills with <SidebarTrigger />. This component never subscribes to the
   * sidebar context itself, so it keeps rendering outside a SidebarProvider.
   */
  trigger?: React.ReactNode;
  className?: string;
}

/** The single main-area top bar. New chat lives in the sidebar, not here. */
export function ChatHeader({ title, brand, trigger, className }: ChatHeaderProps) {
  return (
    <header className={cn("flex h-13 items-center gap-2.5 border-b bg-background px-4", className)}>
      {trigger}
      {brand}
      {title ? (
        <span className="min-w-0 truncate text-base leading-6 font-medium">{title}</span>
      ) : null}
    </header>
  );
}
